// https://vuex.vuejs.org/en/mutations.html

import { set, toggle } from "@/utils/vuex";

export default {
  setTab: set("activeTab"),

  setProject(state, payload) {
    state.activeTab = 0;
    state.form = null;
    let data = _.cloneDeep(payload);
    state.datarooms = data.datarooms;
    delete data.datarooms;
    state.form = data;
  },

  saveProfile(state, payload) {
    state.form.name = payload.name;
    state.form.bgcolor = payload.bgcolor;

    if (_.has(payload.bgcolor, "hex")) state.form.bgcolor = payload.bgcolor.hex;

    state.form.logo = payload.logo;
    state.form.ticker = payload.ticker;
    state.form.type = payload.type;
    state.form.view_permission = payload.view_permission;
    state.form.ownertype = payload.ownertype;

    if (state.form.ownertype == "org") {
      state.form.orgname = payload.orgname;
      state.form.orgaddress = payload.orgaddress;
    } else {
      delete state.form.orgname;
      delete state.form.orgaddress;
    }

    state.form.country = payload.country;
  },

  saveDescription(state, payload) {
    state.form.description = payload.description;
    state.form.management = payload.management;
    state.form.leverage = payload.leverage;
    state.form.drawdown = payload.drawdown;
    state.form.management_fee = payload.management_fee;
    state.form.referral_fee = payload.referral_fee;
    state.form.mindeposit = payload.mindeposit;
    state.form.maxdeposit = payload.maxdeposit;
    state.form.maxinvestors = payload.maxinvestors;
  },

  saveDataRoom(state, payload) {
    state.form.dataroom = {};

    if (!_.has(payload, "dataroom")) {
      delete state.form.dataroom;
      return;
    }

    if (payload.dataroom.exchange_id) {
      state.form.dataroom.exchange_id = payload.dataroom.exchange_id;
    }

    state.form.dataroom.apikey = payload.dataroom.apikey;
    state.form.dataroom.secret = payload.dataroom.secret;

    if (payload.dataroom.quote_asset) {
      state.form.dataroom.quote_asset = payload.dataroom.quote_asset;
    }
    if (payload.dataroom.markets) {
      state.form.dataroom.markets = payload.dataroom.markets;
    }
  },
};
